<p-dialog header="QEC Datasets" [style]="{width: '95vw'}" [(visible)]="visible" (onHide)="closeDialog()">
  <app-esgdata-main></app-esgdata-main>
</p-dialog>
